import TaskRecord from './TaskRecord';

class LogicalMemoryRecallTaskRecord extends TaskRecord {

    constructor() {
        super()
        this.taskType = 'LogicalMemoryRecall'
    }

    parseLogExtra(logJson) {
        if (!logJson) return
        if (!logJson['Summary']) return
        this.fileName = logJson['Summary']['RecordingFilename']
    }

    //--
}

export default LogicalMemoryRecallTaskRecord;